'use client';

import { Star, Award } from 'lucide-react';
import { motion } from 'framer-motion';

export default function AgentBadge({ type = 'superagent', className = '' }) {
  if (type === 'superagent') {
    return (
      <motion.div
        className={`inline-flex items-center px-3 py-1.5 rounded-md bg-purple-600 text-white text-xs font-bold uppercase tracking-wide shadow-lg backdrop-blur-sm ${className}`}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <Star className='w-3 h-3 mr-1 fill-current' />
        SuperAgent
      </motion.div>
    );
  }

  if (type === 'trubroker') {
    return (
      <motion.div
        className={`inline-flex items-center px-3 py-1.5 rounded-lg bg-gradient-to-r from-[#006d61] to-[#004c49] text-white text-xs font-semibold shadow-lg backdrop-blur-sm ${className}`}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <Award className='w-3 h-3 mr-1' />
        TruBroker™
      </motion.div>
    );
  }

  return null;
}

// Multi-badge component for agents with multiple badges
export function AgentBadges({ agent, className = '' }) {
  const badges = [];

  // Check boolean flags and add corresponding badges
  if (agent?.is_super_agent) {
    badges.push('superagent');
  }

  if (agent?.is_trubroker) {
    badges.push('trubroker');
  }

  if (badges.length === 0) return null;

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {badges.map((badge, index) => (
        <motion.div
          key={badge}
          initial={{ opacity: 0, scale: 0.8, y: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.1 }}
        >
          <AgentBadge type={badge} />
        </motion.div>
      ))}
    </div>
  );
}
